import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import { ExportToExcel } from "../../Common/ExportToExcel";
import { getUnitreportslist } from "../../../store/Reports/actions";
import "../reports.scss";
var date = new Date(),
  y = date.getFullYear(),
  m = date.getMonth();
class UnitWiseReportList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getUnitreportslist({
      ...this.props.params,
      start_date:
        this.props.params.start_date == null ||
        this.props.params.start_date === ""
          ? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
          : this.props.params.start_date,
      end_date:
        this.props.params.end_date == null || this.props.params.end_date === ""
          ? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
          : moment(this.props.params.end_date)
              .add(1, "days")
              .format("YYYY-MM-DD"),
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print">
                    <Link
                      to="/unitreport"
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <ExportToExcel
                          apiData={this.props.Unit_ReportData.map((unit) => {
                            return {
                              "MR Date": unit.material_request[0].date,
                              "MR No": unit.material_request[0].code,
                              "MR User Name": unit.material_request[0].createdby__username,
                              "Department": unit.material_request[0].userdepartment__name,
                              "Product Name": unit.product.name,
                              "Item Description":unit.material_request[0].mritems__description,
                              "Purpose": unit.material_request[0].description,
                              "PO Code": unit.purchase_order.code,
                              "PO Date": unit.purchase_order.date,
                              "Unit": unit.purchase_order.location,
                              "Name Of the Vendor": unit.purchase_order?.Vendor_Name,
                              "Gross": unit.purchase_order?.gross,
                              // "Received Items": unit.code,
                              "IGP": unit.goodsreceivednote2[0].code,
                              "IGP Date": unit.goodsreceivednote2[0].createdon,
                              "PO Status": unit.purchase_order.po_status,
                            };
                          })}
                          topHeader={[
                            "SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD",
                            "Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP",
                            "Phone No.0884-2326661, 62, Mobile No.9494127893, Email: purchase@sleipl.com, lalitharice@gmail.com",
                            "",
                            "UNIT WISE PENDING REPORT",
                            "",
                          ]}
                          fileName="UNIT WISE PENDING_REPORT"
                        />
                        {/* <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => this.getExcelReport()}
                        >
                          <i className="ri-file-excel-2-line"></i>
                          <span className="d-none d-inline-block ml-1">
                            Excel
                          </span>
                        </Button> */}
                        {/* <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className=" mr-2"
                          // className="download-table-xls-button"
                          table="table-to-xls"
                          filename="tablexls"
                          sheet="tablexls"
                          buttonText="Excel"
                        /> */}
                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" ml-2"
                          onClick={() => window.print()}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-2">
                    <div className="text-center">
                      <span className="display_none printme">
                        <h5 className="card-title-18 pt-2 ">
                          SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                        </h5>
                        <p className="card-title-14 pt-2 mb-0">
                          Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist.
                          - AP
                        </p>
                        <p className="card-title-14 pt-2">
                          Phone No.0884-2326661, 62, Mobile No.9494127893,
                          Email: purchase@sleipl.com, lalitharice@gmail.com
                        </p>
                        <hr />
                      </span>
                      <h5 className="card-title-16 pt-3 ">
                        UNIT WISE PENDING REPORT ({" "}
                        {this.props.params.start_date == null ||
                        this.props.params.start_date === ""
                          ? moment(new Date(y, m, 1)).format("DD-MM-YYYY")
                          : moment(this.props.params.start_date).format(
                              "DD-MM-YYYY"
                            )}{" "}
                        TO{" "}
                        {moment(this.props.params.end_date).format(
                          "DD-MM-YYYY"
                        )}{" "}
                        )
                      </h5>
                    </div>

                    <div className="table-responsive m-0">
                      <Table
                        bordered
                        hover
                        className="mb-0 p-0 table-centered"
                        id="table-to-xls"
                      >
                        <thead className="bg-light text-center ">
                          <tr className="bg-light">
                            <th style={{ width: "10%" }}>
                              <b>MR Date</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>MR No</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>MR User Name</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>Department</b>
                            </th>
                            <th style={{ width: "15%" }}>
                              <b>Product Name</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>Item Description</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>Purpose</b>
                            </th>
                            <th style={{ width: "15%" }}>
                              <b>PO Code</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>PO Date</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>Unit</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>Name Of the Vendor</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>Gross</b>
                            </th>
                            {/* <th style={{ width: "10%" }}>
                              <b>Received Items</b>
                            </th> */}
                           <th style={{ width: "10%" }}>
                              <b>IGP</b>
                            </th>
                            <th style={{ width: "15%" }}>
                              <b>IGP Date</b>
                            </th>
                            <th style={{ width: "15%" }}>
                              <b>PO Status</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.Unit_ReportData.length !== 0 ? (
                            <>
                              {this.props.Unit_ReportData.map((unit, key) => (
                                <tr key={key} className="text-center">
                                  <td>{unit.material_request[0].date}</td>
                                  <td>{unit.material_request[0].code}</td>
                                  <td>{unit.material_request[0].createdby__username}</td>
                                  <td>{unit.material_request[0].userdepartment__name}</td>
                                  <td>{unit.product.name}</td>
                                  <td>{unit.material_request[0].mritems__description}</td>
                                  <td>{unit.material_request[0].description}</td>
                                  <td>{unit.purchase_order?.code} </td>
                                  <td>{unit.purchase_order?.date}</td>
                                  <td>{unit.purchase_order?.location}</td>
                                  <td>{unit.purchase_order?.Vendor_Name}</td>
                                  <td>{unit.purchase_order?.gross} </td>
                                  {/* <td>{unit.code}</td> */}
                                  <td>{unit.goodsreceivednote2[0].code}</td>
                                  <td>{unit.goodsreceivednote2[0].createdon}</td>
                                  <td>{unit.purchase_order.po_status}</td>
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td colspan="9" className="text-center">
                                <span className="font-size-18 text-danger">
                                  Data not available
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { params, reportType, Reportdata, Unit_ReportData } = state.reports;
  return {
    params,
    reportType,
    Reportdata,
    Unit_ReportData,
  };
};

export default connect(mapStatetoProps, {
  getUnitreportslist,
})(UnitWiseReportList);
